import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import LocalizedCurrency from "@insite/content-library/Components/LocalizedCurrency";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { getShowNormalPrice } from "@store/Store/Context/ContextSelectors";
import { getHideAllPricesModeOn } from "@store/Store/Data/HideAllPricesMode/HideAllPricesModeSelector";
import StoreApplicationState from "@store/Store/StoreApplicationState";
import { orderTotalProps } from "@store/theme/common/props/checkout";
import React, { FC } from "react";
import { connect } from "react-redux";

// Poolcorp Custom Code
const mapStateToProps = (state: StoreApplicationState) => ({
    total: state.store.pages.quickOrder.total,
    products: state.store.pages.quickOrder.productInfos, 
    isRetailModeOn: false, // getRetailModeOn(state), // <-- Active once retail subtotal is handled
    showPrices: getShowNormalPrice(state), // getShowPrices(state), // <-- Active once retail subtotal is handled
    hideAllPrices: getHideAllPricesModeOn(state),
});
// Poolcorp Custom Code

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export interface QuickOrderTotalStyles {
    container?: GridContainerProps;
    titleGridItem?: GridItemProps;
    title?: TypographyProps;
    labelGridItem?: GridItemProps;
    label?: TypographyProps;
    valueGridItem?: GridItemProps;
    value?: TypographyProps;
}

const styles: QuickOrderTotalStyles = {
    container: orderTotalProps.container,
    titleGridItem: orderTotalProps.titleGridItem,
    title: orderTotalProps.title,
    labelGridItem: orderTotalProps.labelGridItem,
    valueGridItem: orderTotalProps.valueGridItem,
    value: orderTotalProps.value,
};

const QuickOrderTotal: FC<Props> = ({ total, isRetailModeOn, showPrices, hideAllPrices }) => { // Poolcorp Custom Code
    if (!showPrices) {
        return null;
    }

    return (
        <GridContainer {...styles.container}>
            <GridItem {...styles.titleGridItem}>
                <Typography {...styles.title}>{translate("Quick Order Summary")}</Typography>
            </GridItem>
            {!hideAllPrices && ( // Poolcorp Custom Code
                <>
                    <GridItem {...styles.labelGridItem}>
                        <Typography {...styles.label}>
                            {/* Poolcorp Custom Code - start */}
                            {isRetailModeOn ? translate("Retail Subtotal") : translate("summary_subtotal")}
                            {/* Poolcorp Custom Code - end */}
                        </Typography>
                    </GridItem>
                    <GridItem {...styles.valueGridItem}>
                        <Typography {...styles.value} data-test-selector="cartTotal_subTotal">
                            {isRetailModeOn ? "-" : <LocalizedCurrency amount={total} />}
                        </Typography>
                    </GridItem>
                </>
            )}
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, null)(QuickOrderTotal),
    definition: {
        displayName: "Quick Order Total",
        group: "Quick Order",
        allowedContexts: ["QuickOrderPage"],
    },
};

export default widgetModule;
